<template>
	<v-row>
		<v-col>

			<div
					class="align-center d-flex mb-8 flex-column"
					style="margin-top: calc(-2rem - 1px)"
			>
				 
				 
			</div>

			<ui-box>
				<!-- Name -->
				<div class="align-center d-flex justify-space-between">
					<h5>Basic Info</h5>
				</div>
				<v-divider class="mb-8 mt-4 opacity-80"></v-divider>

				 
				<v-row class="mb-0">
					<v-col class="text-body-2">

						<v-data-table
								hide-default-footer
								hide-default-header
						>
							<template v-slot:body>
								<tr>
									<td class="font-weight-bold table-label">Name</td>
									<td class="table-info">
										{{ messageList.name }}
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold table-label">Description</td>
									<td
											class="table-info"
											:class="{
													'font-italic': !messageList.description,
													'grey--text': !messageList.description
											}"
									>
										{{
											messageList.description || '-'
										}}
									</td>
								</tr>
								<!-- Add more rows as needed -->
							</template>
						</v-data-table>

					</v-col>
					 
				</v-row>
			</ui-box>
			<cancel-form
				:refs="$refs"
				@cancel-action="cancelChanges"
			></cancel-form>
		 

		</v-col>
	</v-row>
</template>

<script>
import { Place } from '../../../../Shared/helpers';

export default {
	name: "ViewPass",
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		messageList: {
			type: Object,
			default: () => ({})
		},
		 
	},
	data() {
		return {
			// localPlaces: []
		}
	},
	methods: {
		getReturnUrl() {
			return `/partner-portal/${ this.partner.id }/message-lists`;
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},	
	},
	computed: {
		
		placesHeaders() {
			return [
				{
					align: 'start',
					mandatory: true,
					text: 'Image',
					value: 'media',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Name/Address',
					value: 'name'
				}
			];
		}
	},
	mounted() {
		//this.places.forEach(place => this.localPlaces.push(new Place(place)));
	}
}
</script>

<style lang="scss" scoped>
.v-data-table > .v-data-table__wrapper > table {
	& > tr {
		& > td {
			padding-bottom: 1rem;
			padding-top: 1rem;
			position: relative;
			vertical-align: top;
		}

		&:not(:last-of-type) > td {
			&::after {
				content: '';
				position: absolute;
				height: 1px;
				background: rgba(0, 0, 0, 0.04);
				bottom: 0;
			}

			&:first-child::after {
				left: 0;
				width: calc(100% - 1rem);
			}

			&:not(:first-child):not(:last-child)::after {
				left: 1rem;
				width: calc(100% - 2rem);
			}

			&:nth-child(2):last-child::after {
				left: 1rem;
				width: calc(100% - 1rem);
			}

			&:last-child::after {
				right: 0;
				white-space: nowrap;
				width: 100%;
			}
		}
	}
}

.table-label {
	padding-right: 1rem;
	white-space: nowrap;
	width: 1%;
}

.table-info {
	border-left: solid 1px rgba(0, 0, 0, 0.08);
	padding-left: 1rem;
}
</style>
